import {
  Box,
  Button,
  Card,
  CardContent,
  Paper,
  Stack,
  Typography,
  TextField,
  Snackbar,
  Alert,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";

function MembershipCard({
  devPort,
  userName,
  membershipType,
  setCurrentMembership,
}) {
  const [hasManagerId, setHasManagerId] = useState(false);
  const [email, setEmail] = useState("");
  const [isEmailChanged, setIsEmailChanged] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    const fetchManagerId = devPort + "system_get_manager/" + userName;
    console.log(fetchManagerId);
    fetch(fetchManagerId, { credentials: "include" })
      .then((response) => {
        console.log(response);
        return response.json();
      })
      .then((data) => {
        console.log(data);
        setHasManagerId(data && data[0][0] !== null);
      });
  }, [devPort, userName]);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    setIsEmailChanged(true);
  };

  const handleSaveEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      window.alert("Please enter a valid email address");
      return;
    }
    setIsEmailChanged(false);
        setShowSuccessMessage(true);
    const fetchUpdateEmail = devPort + "system_update_user_email"
    const emailData = {
      user_name: userName,
      email: email,
    };
    fetch(fetchUpdateEmail, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(emailData),
    })
      .then((response) => {
        console.log(response);
        return response.json();
      })
      .then((data) => {
        console.log(data);
        setIsEmailChanged(false);
        setShowSuccessMessage(true);
      });
  };
  
  const getUserEmail = useCallback(() => {
    const fetchUserEmail = devPort + "system_get_user_email/" + userName;
    fetch(fetchUserEmail, { credentials: "include" })
      .then((response) => {
        console.log(response);
        return response.json();
      })
      .then((data) => {
        console.log("getUserEmail");
        console.log(data);
        setEmail(data[0][0]);
      });
  }, [devPort, userName]);

  useEffect(() => {
    getUserEmail();
  }, [devPort, userName, getUserEmail]);

  return (
    <Paper elevation={24}>
      <Box textAlign="center" data-testid="membership-card">
        <Card>
          <CardContent>
            <Stack gap={2}>
              <Typography variant="h5" component="div">
                {membershipType + " Membership"}
              </Typography>

              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                You are currently enrolled as a {membershipType}
              </Typography>

              <Grid container spacing={2}>
                <Grid size={{ xs: 8 }}>
                  <TextField
                    label="Email"
                    fullWidth
                    variant="outlined"
                    value={email}
                    onChange={handleEmailChange}
                    size="small"
                  />
                </Grid>
                <Grid size={{ xs: 4 }}>
                  <Button
                    variant="contained"
                    fullWidth
                    color="success"
                    disabled={!isEmailChanged}
                    onClick={handleSaveEmail}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>

              {membershipType === "Manager" && (
                <Button
                  color="primary"
                  data-testid="switch-membership-to-player"
                  variant="outlined"
                  onClick={() => setCurrentMembership("player")}
                >
                  {" "}
                  Go to Player Mode
                </Button>
              )}
              {hasManagerId && membershipType === "Player" && (
                <Button
                  color="primary"
                  variant="outlined"
                  data-testid="switch-membership-to-manager"
                  onClick={() => setCurrentMembership("manager")}
                >
                  {" "}
                  Go to Manager Mode
                </Button>
              )}
            </Stack>
          </CardContent>
        </Card>
      </Box>
      <Snackbar
        open={showSuccessMessage}
        autoHideDuration={3000}
        onClose={() => setShowSuccessMessage(false)}
      >
        <Alert onClose={() => setShowSuccessMessage(false)} severity="success" sx={{ width: '100%' }}>
          Email has been successfully updated!
        </Alert>
      </Snackbar>
    </Paper>
  );
}

export default MembershipCard;
